export default __webpack_public_path__ + "static/media/broker-success-icon.f2b3c943.svg";